<template>
  <div class="payload-quick-reply other">
    <table>
      <tr>
        <td class="fix-width"><div class="logo-small"></div></td>
        <td>
          <div class="message">
            <div>{{ conversation.message.payload.message }}</div>
          </div>
          <span class="time">{{
            conversation.createdAt | timeChatFormat
          }}</span>
        </td>
      </tr>
    </table>

    <div v-if="isShow" class="group-answer">
      <div
        v-for="(button, key) in conversation.message.payload.buttons"
        :class="button.title.includes('เมนูก่อนหน้า') ? 'back-menu' : 'answer'"
        :key="key"
        @click="handleButton(button)"
        v-html="button.title"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayloadQuickReply',
  props: {
    conversation: Object,
    isShow: Boolean
  },
  methods: {
    handleButton(button) {
      return this.$parent.handleButton(button)
    }
  }
}
</script>
